import styled from 'styled-components';

export const CreditoCarbonoContainer = styled.div`
  display: flex;
  flex-direction: column;
  -moz-box-pack: center;
  justify-content: center;
  width: 60vw;
  --margin-left: 230px;
  text-align: left;
  --margin-top: 400px;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

/** aquioiiiiiii */

export const Input2 = styled.input`
  padding: 10px;
  margin-bottom: 20px;
  
  border: 2px solid var(--border-default);
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  outline: none;
  width: 250px;

  &:focus {
    border-color: var(--accent);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
`;

export const FormContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ProfileContainerInfo = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5em;
  border-radius: 20px;
  box-shadow: var(--shadow-sm);
  z-index: 2;
  background: var(--surface-1);
  width: ${({ collapsed }) => (collapsed ? "40vw" : "40vw")};
  margin: auto;
  margin-top: 4vh;
  margin-bottom: 4vh;
  position: relative;
  overflow: hidden;
  min-height: 250px;
  margin-bottom: 4vh;

  h3 {
    display: flex;
    align-self: flex-start;
    color: var(--text-heading);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    margin-top: 3.25rem;
    box-sizing: border-box;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 10;
    width: 900px;
    height: 1100px;
    background-size: auto 100%;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.15;
    z-index: -1;
    pointer-events: none;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.26vw;
  width: 50%;

  @media screen and (max-width: 768px) {
    width: 100%;
    gap: 0.5rem;
    align-items: stretch;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.26vw;
  width: 50%;

  @media screen and (max-width: 768px) {
    width: 100%;
    gap: 0.5rem;
    align-items: stretch;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 3vh;
`;

export const Label = styled.label`
  font-weight: bold;
  font-size: 100%;
  color: var(--text-primary);
  margin-bottom: 1vh;
`;

export const Input = styled.input`
  width: 100%;
  max-width: 17vw;
  height: 2.75vh;
  border: 0.052vw solid var(--border-default);
  border-radius: 0.417vw;
  padding: 0.417vw;
    font-size: 0.8vw;
  outline: none;
  background: var(--input-bg);
  transition: all 0.3s ease-in-out;
  color: var(--text-muted);

  &:focus {
    border-color: var(--accent);
    background: var(--surface-1);
    color: var(--text-primary);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: none;
  }
`;

export const ShowInput = styled.input`
  width: 100%;
  max-width: 17vw;
  height: 2.75vh;
  border: 0.052vw solid var(--border-default);
  border-radius: 0.417vw;
  padding: 0.417vw;
    font-size: 0.8vw;
  outline: none;
  background: var(--input-bg);
  transition: all 0.3s ease-in-out;
  color: var(--text-muted);

  &:focus {
    border-color: var(--accent);
    background: var(--surface-1);
    color: var(--text-primary);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: none;
  }
`;

export const StyledSelect = styled.select`
  width: 100%;
  max-width: 18vw;
  height: 5vh;
  border: 0.052vw solid var(--border-default);
  border-radius: 0.417vw;
  padding: 0.417vw;
    font-size: 0.8vw;
  outline: none;
  background: var(--input-bg);
  transition: all 0.3s ease-in-out;
  margin-left: 0;
  color: var(--text-muted);

  &:focus {
    border-color: var(--accent);
    background: var(--surface-1);
    color: var(--text-primary);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: none;
  }
`;

export const ButtonContainer = styled.div`
  display: flex; // Alterado de "row" para "flex"
  justify-content: center; // Adiciona centralização horizontal
  align-items: center; // Mantém alinhamento vertical central
  width: 100%;
  margin-top: 2vh;
  gap: 1vw;
`;

export const StyledButtonVisualizar = styled.button`
  background-color: var(--accent);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 6px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 75%;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 7vw;
  height: 5vh;
  z-index: 1;

  :hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    font-size: 12px;
    width: 130px;
    height: 30px;
  }
`;

export const Divider = styled.hr`
  width: 100%;
  height: 1px;
  background-color: var(--border-default);
  border: none;
  margin: 24px 0;
`;
